import classNames from 'classnames'

import Accordion from '../../Accordion'
import AccordionLinks from '../../Accordion/AccordionLinks'
import Button from 'content-components/_Primatives/Button'
import EmailOfTheDay from '../../EmailOfTheDay'
import FooterLegal from '../../Menus/FooterLegal'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

import { Props } from '..'
import type { LinkType, MenuType } from 'types'

type MainLinks = LinkType & { below: MenuType[] }

const formatAccordion = (mainLinks: MainLinks[]) =>
  mainLinks.map(({ text: headerText, below }) => ({
    summary: headerText,
    details: <AccordionLinks links={below} />,
  }))

function FooterMobile(props: Props) {
  const {
    className,
    copyrightText,
    emailOfTheDay,
    findABoxLink,
    legalLabelText,
    legalLinks,
    mainLinks,
  } = props
  const { text: findBoxLinkText, url: findBoxLinkUrl } = findABoxLink

  return (
    <footer className={classNames(style.wrapper, className)}>
      <Accordion
        className={style.accordion}
        items={formatAccordion(mainLinks)}
        variant='gray-condensed'
      />
      <Button
        aria-label={findBoxLinkText} // integrates with analytics
        className={style.findBoxLink}
        url={findBoxLinkUrl}
        variant='primaryBlue'
      >
        {findBoxLinkText}
      </Button>
      <EmailOfTheDay {...emailOfTheDay} className={style.emailOfTheDay} />
      <Paragraph className={style.copyright} small>
        {copyrightText}
      </Paragraph>
      <FooterLegal
        aria-label={legalLabelText}
        className={style.footerLegal}
        links={legalLinks}
      />
    </footer>
  )
}

export default FooterMobile
